import { VerifyChangeToAdminTokenMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const verifyChangeToAdminTokenHandler =
  graphql.mutation<VerifyChangeToAdminTokenMutation>(
    "verifyChangeToAdminToken",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          verifyChangeToAdminToken: {
            result: true,
          },
        },
      });
    }
  );
